// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"ab08765c","325":"31617be6","455":"9bee4a85","496":"44f1f10a","568":"878f2f35","581":"fed1e0c9"}[chunkId] + ".chunk.js";
};